<template>
  <v-col cols="12" class="px-0">
    <!-- LOADING -->
    <div v-if="estadoFinal === 'loading'" class="text-center py-8">
      <v-progress-circular :size="sizeLoading" :width="widthLoading" :color="colorLoading" indeterminate />
      <div class="mt-3" style="font-size: 18px; font-weight: 500">
        {{ mensajeLoadingFinal }}
      </div>
    </div>

    <!-- ALERTA -->
    <v-alert v-else-if="mostrarAlerta" :type="alerta.type" :color="alerta.color" :text="alerta.text" class="mb-0">
      <div class="text-center" style="font-size: 16px">
        {{ alerta.mensaje }}
      </div>
    </v-alert>

    <!-- CONTENIDO -->
    <slot v-else />
  </v-col>
</template>

<script>
function esVacio(valor) {
  if (valor === null || valor === undefined) return true
  if (Array.isArray(valor)) return valor.length === 0
  if (typeof valor === "object") return Object.keys(valor).length === 0
  return false
}

function esEstadoValido(v) {
  return ["empty", "info", "warning", "error", "success", "loading"].includes(v)
}

const ESTILOS_DEFAULT = {
  empty: { type: "info", color: "blue-grey", text: true },
  info: { type: "info", color: "blue-grey", text: true },
  warning: { type: "warning", color: "orange", text: true },
  error: { type: "error", color: "red", text: true },
  success: { type: "success", color: "green", text: true },
}

export default {
  name: "MxEstadoPanel",
  props: {
    // Control principal
    loading: { type: Boolean, default: false },
    estado: { type: String, default: "", validator: esEstadoValido },

    // Data para detectar "empty"
    response: { type: [Object, Array, null], default: null },
    mostrarVacio: { type: Boolean, default: true },
    mensajeVacio: { type: String, default: "Rellene los datos y realice la consulta" },

    // Mensaje manual (si existe, muestra alerta)
    mensaje: { type: String, default: "" },
    tipoMensaje: { type: String, default: "info", validator: esEstadoValido },

    // Error (bool o string)
    error: { type: [Boolean, String], default: false },
    mensajeError: { type: String, default: "Ocurrió un error" },

    // Loading
    mensajeLoading: { type: String, default: "Cargando..." },
    colorLoading: { type: String, default: "green" },
    sizeLoading: { type: [Number, String], default: 70 },
    widthLoading: { type: [Number, String], default: 7 },

    // Overrides por estado (opcional)
    estilos: { type: Object, default: () => ({}) },
  },
  computed: {
    hayError() {
      return this.error === true || (typeof this.error === "string" && this.error.trim().length > 0)
    },
    mensajeErrorFinal() {
      if (typeof this.error === "string" && this.error.trim().length > 0) return this.error.trim()
      return this.mensajeError
    },
    estaVacio() {
      return this.mostrarVacio && esVacio(this.response)
    },
    estadoFinal() {
      if (this.loading) return "loading"
      if (this.estado) return this.estado
      if (this.hayError) return "error"
      if (this.mensaje && this.mensaje.trim().length > 0) return this.tipoMensaje || "info"
      if (this.estaVacio) return "empty"
      return ""
    },
    mostrarAlerta() {
      return this.estadoFinal !== "" && this.estadoFinal !== "loading"
    },
    mensajeLoadingFinal() {
      return this.mensajeLoading || "Cargando..."
    },
    alerta() {
      const base = ESTILOS_DEFAULT[this.estadoFinal] || ESTILOS_DEFAULT.info
      const override = (this.estilos && this.estilos[this.estadoFinal]) ? this.estilos[this.estadoFinal] : {}

      let msg = ""
      if (this.estadoFinal === "error") msg = this.mensajeErrorFinal
      else if (this.estadoFinal === "empty") msg = this.mensajeVacio
      else msg = (this.mensaje && this.mensaje.trim().length > 0) ? this.mensaje : this.mensajeVacio

      return {
        type: override.type || base.type,
        color: override.color || base.color,
        text: (typeof override.text === "boolean") ? override.text : base.text,
        mensaje: msg,
      }
    },
  },
}
</script>
